module.exports = __webpack_public_path__ + "img/log-left.9486257c.png";